import { AxiosError } from 'axios';
import { f7 } from 'framework7-react';
import { useState } from 'react';
import { serviceStop } from '@/api/linkDriveApi';
import {
  ServiceStopApiParams,
  ServiceStopApiResponse,
} from '@/types/api/linkDriveApi';

interface Args {
  params: ServiceStopApiParams;
  resolve: () => void;
}

export const useServiceStop = () => {
  const [data, setData] = useState<ServiceStopApiResponse['data']>();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<AxiosError>();
  const stopService = async (args: Args) => {
    try {
      const { data } = await serviceStop(args.params);
      setData(data);
      if (data.success) args.resolve();
      if (!data.success) {
        f7.dialog.alert(
          data?.error?.message ?? 'エラーが発生しました',
          '',
          () => {
            f7.dialog.close();
          },
        );
      }
    } catch (err) {
      setError(err as AxiosError);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    isLoading,
    data,
    stopService,
    error,
  };
};
